import React, { forwardRef } from "react";
import {
  RadialBarChart,
  RadialBar,
  Tooltip,
  PolarAngleAxis,
  ResponsiveContainer,
  Legend,
} from "recharts";
import LegendMenubar from "../../../Operation Audit/LegendMenuBar/LegendMenubarContainer";
import variables from "../../../../../themes/base/styles/variables";

export const operationAuditGraphStyles = {
  toolTipStyle: {
    width: variables.fullWidth,
    height: variables.fullHeight,
    backgroundColor: variables.bodyBg,
    padding: variables.customizedTooltipPadding,
    border: variables.customizedTooltipBorder,
  },
};

const CustomTooltip = (legendData) => {
  const dataState = legendData?.legendData?.find(
    (item) => item.name === legendData?.payload?.[0]?.payload?.name
  );
  if (legendData && legendData.payload?.length) {
    return (
      <div style={operationAuditGraphStyles.toolTipStyle}>
        <p
          style={{ color: legendData.payload[0].payload.fill }}
        >{`Name: ${dataState.name}`}</p>
        <p
          style={{ color: legendData.payload[0].payload.fill }}
        >{`Completed Audit : ${dataState.completedAudit}`}</p>
        <p
          style={{ color: legendData.payload[0].payload.fill }}
        >{`Total Audit : ${dataState.totalAudit}`}</p>
      </div>
    );
  }
  return null;
};

const OperationAuditGraph = forwardRef(
  (
    {
      data,
      width,
      height,
      cx,
      cy,
      innerRadius,
      outerRadius,
      barSize,
      type,
      domain,
      angleAxisId,
      tick,
      minAngle,
      dataKey,
      cornerRadius,
      legendData,
      boxColor2,
      totalAudit,
      dataLegend,
    },
    ref
  ) => {
    return (
      <ResponsiveContainer width={width} height={height}>
        <RadialBarChart
          cx={cx}
          cy={cy}
          data={data}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          barSize={barSize}
        >
          <PolarAngleAxis
            type={type}
            domain={domain}
            angleAxisId={angleAxisId}
            tick={tick}
          />
          <RadialBar
            background
            minAngle={minAngle}
            dataKey={dataKey}
            cornerRadius={cornerRadius}
          />
          <Tooltip
            content={<CustomTooltip legendData={legendData} />}
            cursor={{ fill: "transparent" }}
          />
          <Legend
            content={
              <LegendMenubar
                boxColor2={boxColor2}
                totalAudit={totalAudit}
                dataLegend={dataLegend}
              />
            }
          />
        </RadialBarChart>
      </ResponsiveContainer>
    );
  }
);

export default OperationAuditGraph;
